const COLORS_ARRAY = ['#E328AF', '#FFAB2D', '#7F46F0', '#5ECFFF'];

export { COLORS_ARRAY };
